import React from 'react'
import { Row, Col } from 'react-bootstrap'
import CheckboxMerchantAcctCurrency from './CheckboxMerchantAcctCurrency'

const CheckboxListMerchantAcctCurrency = ({ list = [], text, name, values, onChange, style, required = false, disabled = false, message, ...props }) => {
  const className = required ? "text-grey font-weight-bold medium required" : "text-grey font-weight-bold medium";
  const onListChange = (name, checked, to) => {
    onChange(name, checked, to)
  }

  return (
    <Row className="mt-3 ml-3" >
      <Col className="mb-4">
        <Row>
          <Col className={className}>{text}</Col>
        </Row>
        <Row className="ml-3 my-2 mb-1">
          <Col>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {list.map((obj, index) => {
                return (
                  <CheckboxMerchantAcctCurrency style={{ width: obj.width, marginTop: "10px" }} key={index} to={text} name={obj.name} label={obj.label} checked={obj.checked} onChange={onListChange} disabled={disabled} />
                )
              })}
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default CheckboxListMerchantAcctCurrency
